export function nameof<TObject>(
  obj: TObject,
  key: keyof TObject,
): keyof TObject;
export function nameof<TObject>(key: keyof TObject): keyof TObject;
export function nameof(key1: any, key2?: any): any {
  return key2 ?? key1;
}
